import React, { createRef } from "react";
import useStyles from "./styles";
import CloseIcon from "@material-ui/icons/Close";

import { Grid, Dialog, IconButton, Button } from "@material-ui/core";
import { Images } from "config/images";

const DialogLogout = props => {
	const classes = useStyles();
	const { handleClose, open, handleLogout } = props;
	const nodeRef = createRef();

	return (
		<Dialog
			onClose={handleClose}
			aria-labelledby="customized-dialog-title"
			open={open}
			ref={nodeRef}
		>
			<Grid>
				<Grid classes={{ root: classes.closeButton }}>
					<IconButton aria-label="close" onClick={handleClose}>
						<CloseIcon />
					</IconButton>
				</Grid>
				<Grid classes={{ root: classes.body }}>
					<img
						src={Images.icWarningLogin}
						alt={"icWarningLogin"}
						width={72}
					/>
					<Grid classes={{ root: classes.title }}>
						Bạn có chắc chắn đăng xuất?
					</Grid>
					<Grid container style={{ padding: 10 }}>
						<Grid
							item
							xs={6}
							classes={{
								root: classes.borderRight
							}}
						>
							<Button
								onClick={() => handleClose()}
								classes={{ root: classes.button }}
							>
								Không
							</Button>
						</Grid>
						<Grid item xs={6}>
							<Button
								onClick={() => handleLogout()}
								classes={{ root: classes.button }}
							>
								Có
							</Button>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Dialog>
	);
};

export default DialogLogout;
